// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"styles_fadeIn__5XdWk"};